import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from './swal';
import RoadiesShell from './RoadiesShell';
import { GameHead, TopBar, useSaveScore } from './common';
import { useGameTimer, useRotateNotice } from './hooks';

// s8.php: three quiz questions shown one at a time; correct = green +1, wrong = red + reveal correct.
const QUESTIONS = [
  { title: '1. Christmas falls during _____ season for Kiwis.', options: ['Summer', 'Autumn', 'Winter'], answer: 0 },
  {
    title: '2. The New Zealand Christmas tree is the ____, a coastal species that blooms a bright-red colour in December.',
    options: ['White Pine', 'Sugar Pine', 'Pohutukawa'],
    answer: 2,
  },
  {
    title: '3. Kiwis gather for a casual cookout of ______, ___ and seasonal vegetables.',
    options: ['Cake / Wine', 'Seafood / Meat', 'Dance / Games'],
    answer: 1,
  },
];

function Stage8Game() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const game = useSelector((s) => s.roadies.game);
  const rotate = useRotateNotice();
  const timer = useGameTimer(true, game?.time);
  const save = useSaveScore();

  const base = game?.totalScore || 0;
  const scoreRef = useRef(base);
  const [points, setPoints] = useState(base);
  const [pos, setPos] = useState(0);
  const [selected, setSelected] = useState(null);
  const [revealed, setRevealed] = useState(false);
  const busy = useRef(false);

  const q = QUESTIONS[pos];
  const isLast = pos === QUESTIONS.length - 1;

  const cls = (i) => {
    if (!revealed) return i === selected ? 'rd-option selected' : 'rd-option';
    if (i === q.answer) return 'rd-option correct';
    if (i === selected) return 'rd-option wrong';
    return 'rd-option';
  };

  const submit = async () => {
    if (busy.current || revealed) return;
    if (selected === null) {
      Swal.fire('', 'Please select an option', 'info');
      return;
    }
    busy.current = true;
    setRevealed(true);
    if (selected === q.answer) {
      scoreRef.current += 1;
      setPoints(scoreRef.current);
    }
    const delay = isLast ? 3000 : 2000;
    setTimeout(async () => {
      if (isLast) {
        const state = await save(8, scoreRef.current, timer.current());
        if (state) navigate({ pathname: '/thankyou', search });
        else busy.current = false;
        return;
      }
      setPos((p) => p + 1);
      setSelected(null);
      setRevealed(false);
      busy.current = false;
    }, delay);
  };

  return (
    <>
      {rotate && <div className="rd-rotate">Please rotate your device for the best experience</div>}
      <TopBar time={timer.text} points={points} />
      <GameHead title="New Zealand" highlight="Quiz up to unlock holiday rituals in New Zealand" />

      <div className="rd-game">
        <div className="rd-page-box">
          <div className="rd-question">{q.title}</div>
          <div className="rd-options">
            {q.options.map((label, i) => (
              <div key={i} className={cls(i)} onClick={() => !revealed && setSelected(i)}>
                {label}
              </div>
            ))}
          </div>
        </div>
        <div>
          <button type="button" className="rd-btn" onClick={submit} disabled={revealed}>
            {isLast ? 'Submit' : 'Next'}
          </button>
        </div>
      </div>
    </>
  );
}

export default function RoadiesStage8() {
  return (
    <RoadiesShell bg="phill.jpg" bgMob="phill-mob.jpg" stage={8} className="rd-stage rd-stage8">
      <Stage8Game />
    </RoadiesShell>
  );
}
